import axios from 'axios'

export default {
  /**
   * Gets and sets all owned placesõ
   */
  getOwnedPlaces: async ({ commit, rootState, dispatch }) => {
    commit(
      'app/setLoading',
      { type: 'getOwnedPlaces', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(`${process.env.VUE_APP_URL}/adminapi/owner/adminplaces`, config)
        .then(response => {
          commit('setOwnedPlaces', response.data)
          commit(
            'app/setLoading',
            { type: 'getOwnedPlaces', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getOwnedPlaces', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Gets and sets places
   */
  getPlaces: async ({ commit, rootState, dispatch }) => {
    commit('app/setLoading', { type: 'getPlaces', state: true }, { root: true })
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(`${process.env.VUE_APP_URL}/adminapi/places`, config)
        .then(response => {
          commit('setPlaces', response.data)
          let totalSpots = 0
          let availableSpots = 0
          const localPlaces = []
          response.data.forEach(place => {
            localPlaces.push(place)
            if (
              Array.isArray(place.ChildPlaces) &&
              place.ChildPlaces.length > 0
            ) {
              place.ChildPlaces.forEach(child => {
                child.isChildPlace = true
                localPlaces.push(child)
              })
            }
            if (place.Id !== 1 && place.Operator === 'B') {
              totalSpots += place.TotalSpots
              availableSpots += place.AvailableSpots
            }
          })
          commit('setPlaces', localPlaces)
          commit('setTotalSpots', totalSpots)
          commit('setAvailableSpots', availableSpots)
          commit(
            'app/setLoading',
            { type: 'getPlaces', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getPlaces', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Gets place by place id
   * @param {Number} - place id
   */
  getPlace: async ({ commit, rootState, dispatch }, id) => {
    commit('app/setLoading', { type: 'getPlace', state: true }, { root: true })
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(`${process.env.VUE_APP_URL}/adminapi/places/${id}`, config)
        .then(response => {
          commit('setPlace', response.data)
          commit(
            'app/setLoading',
            { type: 'getPlace', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getPlace', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Gets and sets all sessions
   */
  getSessions: async ({ commit, rootState, dispatch }, payload) => {
    commit(
      'app/setLoading',
      { type: 'getSessions', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }

      let search = ''
      if (payload.from) {
        search += `&from=${payload.from}`
      }
      if (payload.to) {
        search += `&to=${payload.to}`
      }
      if (payload.phoneNumber !== '') {
        search += `&phone_number=${payload.phoneNumber}`
      }
      if (payload.placeName !== '') {
        search += `&place_name=${payload.placeName}`
      }
      if (payload.carNumber !== '') {
        search += `&car_number=${payload.carNumber}`
      }
      if (payload.status !== '') {
        search += `&status=${payload.status}`
      }
      if (payload.extraFilter !== '') {
        search += `&extra_filter=${payload.extraFilter}`
      }

      await axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/parkingsessions?page=${payload.page}&page_size=${payload.pageSize}${search}`,
          config
        )
        .then(response => {
          commit('setSessions', response.data)
          let totalSpots = 0
          let availableSpots = 0
          response.data.forEach(session => {
            if (session.Id !== 1 && session.Operator === 'B') {
              totalSpots += session.TotalSpots
              availableSpots += session.AvailableSpots
            }
          })
          commit('setTotalSpots', totalSpots)
          commit('setAvailableSpots', availableSpots)

          const nextAvailablePage = parseInt(
            response.headers['x-next-page'],
            10
          )

          commit('setNextAvailablePage', nextAvailablePage)

          commit(
            'app/setLoading',
            { type: 'getSessions', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getSessions', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  putSession: async ({ commit, rootState, dispatch }, payload) => {
    commit(
      'app/setLoading',
      { type: 'putSession', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .put(
          `${process.env.VUE_APP_URL}/adminapi/parkingsessions/${payload.Id}`,
          payload,
          config
        )
        .then(response => {
          commit('setSessionInSessionsArray', response)
          commit(
            'app/setLoading',
            { type: 'putSession', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'putSession', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  postSession({ commit, rootState, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'postSession', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/parkingsessions`,
          payload,
          config
        )
        .then(response => {
          resolve(response)
          commit('addSession', response)
          commit(
            'app/setLoading',
            { type: 'postSession', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          reject(error)
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'error',
              message: error.response.data
                ? error.response.data.Error
                : `Something went wrong! Please try again later.`
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'postSession', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    })
  },
  deleteParkingSession({ commit, rootState, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'deleteParkingSession', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` },
        data: payload
      }

      axios
        .delete(
          `${process.env.VUE_APP_URL}/adminapi/parkingsessions/${payload.Id}`,
          config
        )
        .then(response => {
          const session = response.data
          resolve(session)

          commit('removeSessionFromSessionsArray', payload.Id)

          commit(
            'app/setLoading',
            { type: 'deleteParkingSession', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          reject(error)

          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'error',
              message:
                error.response && error.response.data
                  ? error.response.data.Error
                  : `Something went wrong! Please try again later.`
            },
            { root: true }
          )

          commit(
            'app/setLoading',
            { type: 'deleteParkingSession', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })

          if (error.response && error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    })
  },
  modifySession: async ({ commit, rootState, dispatch }, payload) => {
    commit(
      'app/setLoading',
      { type: 'modifySession', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/parkingsession/modify`,
          payload,
          config
        )
        .then(response => {
          commit('setSessionInSessionsArray', response.data)
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: 'Sesssion saved successfully'
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'modifySession', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'modifySession', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Gets session invoices by session id
   * @param {Number} - session id
   * @return {Array} - array of invoices
   */
  getSessionInvoices({ commit, rootState, dispatch }, id) {
    commit(
      'app/setLoading',
      { type: 'getSessionInvoices', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    return new Promise((resolve, reject) => {
      try {
        const config = {
          headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
        }
        axios
          .get(
            `${process.env.VUE_APP_URL}/adminapi/parkingsessions/${id}/invoices`,
            config
          )
          .then(response => {
            resolve(response.data)
            commit(
              'app/setLoading',
              { type: 'getSessionInvoices', state: false },
              { root: true }
            )
            commit('app/setError', null, { root: true })
          })
          .catch(error => {
            if (error.response.status === 401) {
              dispatch('authentication/logout', null, { root: true })
            }
          })
      } catch (error) {
        reject(error)
        commit(
          'app/setLoading',
          { type: 'getSessionInvoices', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      }
    })
  },
  /**
   * Gets session payment logs by session id
   * @param {Number} - session id
   * @return {Array} - array of payment logs
   */
  getSessionPaymentLogs({ commit, rootState, dispatch }, id) {
    commit(
      'app/setLoading',
      { type: 'getSessionPaymentLogs', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    return new Promise((resolve, reject) => {
      try {
        const config = {
          headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
        }
        axios
          .get(
            `${process.env.VUE_APP_URL}/adminapi/parkingsessions/${id}/paymentlogs`,
            config
          )
          .then(response => {
            resolve(response.data)
            commit(
              'app/setLoading',
              { type: 'getSessionPaymentLogs', state: false },
              { root: true }
            )
            commit('app/setError', null, { root: true })
          })
          .catch(error => {
            if (error.response.status === 401) {
              dispatch('authentication/logout', null, { root: true })
            }
          })
      } catch (error) {
        reject(error)
        commit(
          'app/setLoading',
          { type: 'getSessionPaymentLogs', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      }
    })
  },
  /**
   * Gets LPR event by event id
   * @param {Number} - event id
   * @return {Object} - event object
   */
  getLPREvent({ commit, rootState, dispatch }, id) {
    commit(
      'app/setLoading',
      { type: 'getLPREvent', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    return new Promise((resolve, reject) => {
      try {
        const config = {
          headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
        }
        axios
          .get(`${process.env.VUE_APP_URL}/adminapi/lpr-events/${id}`, config)
          .then(response => {
            const lprEvent = response.data
            lprEvent.Image = `data:image/jpg;base64,${lprEvent.Image}`
            resolve(lprEvent)
            commit(
              'app/setLoading',
              { type: 'getLPREvent', state: false },
              { root: true }
            )
            commit('app/setError', null, { root: true })
          })
          .catch(error => {
            if (error.response.status === 401) {
              dispatch('authentication/logout', null, { root: true })
            }
          })
      } catch (error) {
        reject(error)
        commit(
          'app/setLoading',
          { type: 'getLPREvent', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      }
    })
  },
  postPrivilegedEndParkingSession: async (
    { commit, rootState, dispatch },
    payload
  ) => {
    commit(
      'app/setLoading',
      { type: 'postPrivilegedEndParkingSession', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/parkingsessions/end`,
          payload,
          config
        )
        .then(response => {
          commit('setSessionKeyValueInSessionsArray', {
            SessionId: payload.ParkingSessionId,
            key: 'EndTime',
            value: response.data.EndTime
          })
          commit('setSessionKeyValueInSessionsArray', {
            SessionId: payload.ParkingSessionId,
            key: 'Status',
            value: response.data.Status
          })
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: 'Sesssion ended successfully'
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'postPrivilegedEndParkingSession', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      if (error.response.status === 401) {
        dispatch('authentication/logout', null, { root: true })
      }
      commit(
        'app/setLoading',
        { type: 'postPrivilegedEndParkingSession', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message:
            error.response && error.response.data
              ? error.response.data.Error
              : payload.this.$vuetify.lang.t('$vuetify.ERROR_GLOBAL')
        },
        { root: true }
      )
    }
  }
}
